import axios from "axios";
import commonServices from "@/shared/commonServices";
import { mapGetters } from "vuex";
export default {
  mixins: [commonServices],
  data: function () {
    return {};
  },
  computed: {
    ...mapGetters({
      posData: "posData",
    }),
  },
  methods: {
    addZeroBefore(n) {
      return (n < 10 ? "0" : "") + n;
    },
    getCurrentDateTime() {
      let dateTimeStr = "";
      const nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth() + 1;
      let day = nowDate.getDate();
      var time =
        this.addZeroBefore(nowDate.getHours()) +
        ":" +
        this.addZeroBefore(nowDate.getMinutes()) +
        ":" +
        this.addZeroBefore(nowDate.getSeconds());
      dateTimeStr = year + "-" + month + "-" + day + " " + time;
      return dateTimeStr;
    },
    handleSyncItems: async function () {
      this.showInfo(`Started Syncing Items To URA`);
      try {
        
        let offset = 0;
        let itemsSuccessfullySynced = [];
        let total = 99999999;
        let dataURL = this.apiURL + "SyncEfris/generateSyncItems";
        let productsCounter = 0;
        this.showInfo(`Working... <br> Synced To URA <span class="count-ura">0</span> Items`);
        while (offset < total) {
          let reqJson = {
            username: localStorage.username,
            offset: offset
          };  
          let response = await axios.post(dataURL, reqJson);
          if (response.data.status === "success" && response.data.reqItems) {
            
            for (const reqItem of response.data.reqItems) {
              let req = {
                data: {
                  content: reqItem.req_obj,
                  signature: "",
                  dataDescription: {
                    codeType: "0",
                    encryptCode: "0",
                    zipCode: "0",
                  },
                },
                globalInfo: {
                  appId: "AP04",
                  version: "1.1.20191201",
                  dataExchangeId: "923048922301214123",
                  interfaceCode: "T130",
                  requestCode: "TP",
                  requestTime: this.getCurrentDateTime(),
                  responseCode: "TA",
                  userName: localStorage.getItem("username"),
                  deviceMAC: "FFFFFFFFFFFF",
                  deviceNo: "TCS7fbfeb469484346",
                  tin: "1010950825",
                  brn: "",
                  taxpayerID: "ETX999000001356715",
                  longitude: "116.397128",
                  latitude: "39.916527",
                  extendField: {
                    responseDateFormat: "dd/MM/yyyy",
                    responseTimeFormat: "dd/MM/yyyy HH:mm:ss",
                    referenceNo: "21PL010020807",
                  },
                },
                returnStateInfo: {
                  returnCode: "",
                  returnMessage: "",
                },
              };
              let resp = await axios.post(this.posData.efris_link, req);
              if(resp.data.returnStateInfo.returnMessage == 'SUCCESS'){
                if(!reqItem.ura_synced)
                itemsSuccessfullySynced.push(reqItem.item_code);
                productsCounter+=1
                document.querySelector(".count-ura").innerHTML = productsCounter;
              }
            } 
            offset += 1000;
            total = response.data.items_count
          }else{
            this.showSuccess("No Items To Sync");
            break;
          }
          
        }
        if(itemsSuccessfullySynced.length != 0){
          dataURL = this.apiURL + "SyncEfris/setSyncedItems";
          let finalResp = await axios.post(dataURL, {
            items: itemsSuccessfullySynced,
          });
          if (finalResp.data.status == "success") {
            this.showSuccess(
              `Synced Successfully ${itemsSuccessfullySynced.length} Items`
            );
          } else {
            this.showAlert("Failed To Sync");
          }
        }
        
      } catch (error) {
        console.log(error);
        this.showAlert("Failed To Sync");
      }
    },
    handleSyncPurchaseInvoices: async function () {
      this.showInfo(`Started Syncing Purchase Invoices To URA`);
      try {
        
        let offset = 0;
        let itemsSuccessfullySynced = [];
        let total = 99999999;
        let dataURL = this.apiURL + "SyncEfris/generateSyncPurchaseInvoices";
        let productsCounter = 0;
        this.showInfo(`Working... <br> Synced To URA <span class="count-ura">0</span> Purchase Invoices`);
        while (offset < total) {
          let reqJson = {
            username: localStorage.username,
            offset: offset
          };  
          let response = await axios.post(dataURL, reqJson);
          if (response.data.status === "success" && response.data.reqItems) {
            
            for (const reqItem of response.data.reqItems) {
              let req = {
                data: {
                  content: reqItem.req_obj,
                  signature: "",
                  dataDescription: {
                    codeType: "0",
                    encryptCode: "0",
                    zipCode: "0",
                  },
                },
                globalInfo: {
                  appId: "AP04",
                  version: "1.1.20191201",
                  dataExchangeId: "923048922301214123",
                  interfaceCode: "T131",
                  requestCode: "TP",
                  requestTime: this.getCurrentDateTime(),
                  responseCode: "TA",
                  userName: localStorage.getItem("username"),
                  deviceMAC: "FFFFFFFFFFFF",
                  deviceNo: "TCS7fbfeb469484346",
                  tin: "1010950825",
                  brn: "",
                  taxpayerID: "ETX999000001356715",
                  longitude: "116.397128",
                  latitude: "39.916527",
                  extendField: {
                    responseDateFormat: "dd/MM/yyyy",
                    responseTimeFormat: "dd/MM/yyyy HH:mm:ss",
                    referenceNo: "21PL010020807",
                  },
                },
                returnStateInfo: {
                  returnCode: "",
                  returnMessage: "",
                },
              };
              let resp = await axios.post(this.posData.efris_link, req);
              if(resp.data.returnStateInfo.returnMessage == 'SUCCESS'){
                if(!reqItem.ura_synced)
                itemsSuccessfullySynced.push(reqItem.purchase_invoice_id);
                productsCounter+=1
                document.querySelector(".count-ura").innerHTML = productsCounter;
              }
            } 
            offset += 1000;
            total = response.data.items_count
          }else{
            this.showSuccess("No Items To Sync");
            break;
          }
          
        }
        if(itemsSuccessfullySynced.length != 0){
          dataURL = this.apiURL + "SyncEfris/setSyncedPurchaseInvoices";
          let finalResp = await axios.post(dataURL, {
            items: itemsSuccessfullySynced,
          });
          if (finalResp.data.status == "success") {
            this.showSuccess(
              `Synced Successfully ${itemsSuccessfullySynced.length} Items`
            );
          } else {
            this.showAlert("Failed To Sync");
          }
        }
        
      } catch (error) {
        console.log(error);
        this.showAlert("Failed To Sync");
      }
    },
    handleSyncStockEntries: async function (reason) {
      this.showInfo(`Started Syncing To URA`);
      try {
        
        let offset = 0;
        let itemsSuccessfullySynced = [];
        let total = 99999999;
        let dataURL = this.apiURL + "SyncEfris/generateSyncStockEntries";
        let productsCounter = 0;
        this.showInfo(`Working... <br> Synced To URA <span class="count-ura">0</span> Stock Entry(${reason})`);
        while (offset < total) {
          let reqJson = {
            username: localStorage.username,
            offset: offset,
            reason
          };  
          let response = await axios.post(dataURL, reqJson);
          if (response.data.status === "success" && response.data.reqItems) {
            
            for (const reqItem of response.data.reqItems) {
              let req = {
                data: {
                  content: reqItem.req_obj,
                  signature: "",
                  dataDescription: {
                    codeType: "0",
                    encryptCode: "0",
                    zipCode: "0",
                  },
                },
                globalInfo: {
                  appId: "AP04",
                  version: "1.1.20191201",
                  dataExchangeId: "923048922301214123",
                  interfaceCode: "T131",
                  requestCode: "TP",
                  requestTime: this.getCurrentDateTime(),
                  responseCode: "TA",
                  userName: localStorage.getItem("username"),
                  deviceMAC: "FFFFFFFFFFFF",
                  deviceNo: "TCS7fbfeb469484346",
                  tin: "1010950825",
                  brn: "",
                  taxpayerID: "ETX999000001356715",
                  longitude: "116.397128",
                  latitude: "39.916527",
                  extendField: {
                    responseDateFormat: "dd/MM/yyyy",
                    responseTimeFormat: "dd/MM/yyyy HH:mm:ss",
                    referenceNo: "21PL010020807",
                  },
                },
                returnStateInfo: {
                  returnCode: "",
                  returnMessage: "",
                },
              };
              let resp = await axios.post(this.posData.efris_link, req);
              if(resp.data.returnStateInfo.returnMessage == 'SUCCESS'){
                if(!reqItem.ura_synced)
                itemsSuccessfullySynced.push(reqItem.stock_entry_id);
                productsCounter+=1
                document.querySelector(".count-ura").innerHTML = productsCounter;
              }
            } 
            offset += 1000;
            total = response.data.items_count
          }else{
            this.showSuccess("No Items To Sync");
            break;
          }
          
        }
        if(itemsSuccessfullySynced.length != 0){
          dataURL = this.apiURL + "SyncEfris/setSyncedStockEntries";
          let finalResp = await axios.post(dataURL, {
            items: itemsSuccessfullySynced,
          });
          if (finalResp.data.status == "success") {
            this.showSuccess(
              `Synced Successfully ${itemsSuccessfullySynced.length} Items`
            );
          } else {
            this.showAlert("Failed To Sync");
          }
        }
        
      } catch (error) {
        console.log(error);
        this.showAlert("Failed To Sync");
      }
    },
  },
  mounted(){
    if (localStorage.userId === undefined) {
      this.$router.push({ name: 'login' });
    }
    this.handleLanguage()
  }
};
